const USERNAME_MIN_LENGTH = 3;
const USERNAME_MAX_LENGTH = 15;
const PASSWORD_MIN_LENGTH = 6;
const PASSWORD_MAX_LENGTH = 30;

module.exports = {
  email: isValidEmail,
  fullname: isValidFullname,
  url: isValidUrl,
  hex: isValidHex,
  username: isValidUsername,
  hasOnlyEnglishLetters: hasOnlyEnglishLetters,
  isPhoneNumber: isPhoneNumber,
  USERNAME_MIN_LENGTH,
  USERNAME_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
  isMessageWithRichText
};

function isPhoneNumber(phone) {
  var phoneno = /^\d{9,10}$/;
  if (phone.match(phoneno)) {
    return true;
  } else {
    return false;
  }
}

function isValidEmail(str) {
  var pattern = /^(([a-zA-Z\d_\-\+\.]+)@([a-zA-Z\d_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z\d_\-\.]+)@([a-zA-Z\d_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
  return !!pattern.test(str);
}

function isValidFullname(str) {
  // only English letters and spaces, 3 to 20 characters.
  var pattern = /^([\w\ ](?![0-9\_])){3,20}$/;

  return !!pattern.test(str);
}

function hasOnlyEnglishLetters(str) {
  var pattern = /^[A-Za-z\ ]+$/;

  return !!pattern.test(str);
}

function isValidUrl(str) {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.,~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator

  return !!pattern.test(str);
}

function isValidHex(str) {
  var pattern = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

  return !!pattern.test(str);
}

function isValidUsername(str) {
  // var pattern = /[\u00BF-\u1FFF\u2C00-\uD7FFֿֿֿa-zA-Z0-9\-\.]{2,}$/;
  var pattern = new RegExp(`^[_a-zA-Z0-9]{${USERNAME_MIN_LENGTH},${USERNAME_MAX_LENGTH}}$`);

  return !!pattern.test(str);
}

function isMessageWithRichText(input) {
  // Looking for Emojis and HTML tags in the string
  return /<\/?[a-z][\s\S]*>|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g.test(
    input
  );
}
